import type { NavItemDividerType, NavItemType } from "@/components/_untitled/application/app-navigation/config.ts";
import { NavList } from "@/components/_untitled/application/app-navigation/base-components/nav-list.tsx";
import { NavAccountCard } from "@/components/_untitled/application/app-navigation/base-components/nav-account-card.tsx";
import {
    MobileNavigationHeader
} from "@/components/_untitled/application/app-navigation/base-components/mobile-header.tsx";
import React, { type ReactElement } from "react";

interface SidebarNavigationProps {
    /** URL of the currently active item. */
    activeUrl?: string;
    /** List of items to display. */
    items: (NavItemType | NavItemDividerType)[];
    /** Logo to display */
    logo: ReactElement;
    /** Translate Component */
    languageSwitch: ReactElement;
    /** Optional account section (defaults to NavAccountCard) */
    accountSection?: ReactElement;
}

export const SidebarNavigation = ({
                                      activeUrl,
                                      items,
                                      logo,
                                      languageSwitch,
                                      accountSection
                                  }: SidebarNavigationProps) => {
    const MAIN_SIDEBAR_WIDTH = 292;

    const content = (
        <aside
            data-testid="sidebar"
            style={
                {
                    "--width": `${ MAIN_SIDEBAR_WIDTH }px`,
                } as React.CSSProperties
            }
            className="flex h-full w-full max-w-full flex-col justify-between overflow-y-auto border-[#e9eaeb] bg-white shadow-sm md:border-e lg:w-(--width) lg:rounded-xl lg:border lg:pt-5"
        >
            <div className="flex flex-col gap-5 ps-5 pe-5 pt-8 lg:pt-0">
                <div className="overflow-visible">
                    { logo }
                </div>
            </div>

            <NavList activeUrl={ activeUrl } items={ items } className="mt-5"/>

            { languageSwitch }

            <div className="mt-auto flex flex-col gap-4 ps-5 pe-5 py-4 lg:gap-4">
                {accountSection || <NavAccountCard/>}
            </div>
        </aside>
    );

    return (
        <>
            {/* Mobile header navigation */ }
            <MobileNavigationHeader logo={ logo }>{ content }</MobileNavigationHeader>

            {/* Desktop sidebar navigation */ }
            <div
                className="hidden lg:fixed lg:inset-y-0 lg:inset-inline-start-0 lg:flex lg:py-1 lg:ps-1">{ content }</div>

            {/* Placeholder to take up physical space because the real sidebar has `fixed` position. */ }
            <div
                style={ {
                    paddingInlineStart: MAIN_SIDEBAR_WIDTH + 4, // Add 4px to account for the padding in the sidebar wrapper
                } }
                className="invisible hidden lg:sticky lg:top-0 lg:bottom-0 lg:inset-inline-start-0 lg:block"
            />
        </>
    );
};
